import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { Flex, FlexColumn } from '../../../../Reusable/Container';
import { Text } from '../../../../Reusable/Text';
import { getDateInLocalTZ, toAbsCurrency, toCurrency } from '../../../../../Utils/util';
import hexToRgba from 'hex-to-rgba';
import LucideIcon from '../../../../Reusable/Button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import PaymentProgressChart from './PaymentProgressChart';
import { Divider } from '../../../../Reusable/Divider';
import BillPaymentTable from '../../BillPaymentTable';
import BillPaymentScheduledTable from '../../BillPaymentScheduledTable';
import { apiPOSTReq } from '../../../../../Utils/api';
import environment from '../../../../../environment';
import { ErrorAlert } from '../../../../Reusable/Alert';
import moment from 'moment';

class PaymentHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false,
            scheduledPayments: this.props.scheduledPayments || [],
            bill: this.props.bill
        };
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        // Check if view mode has changed, refetch payments
        if (this.props.viewMode !== prevProps.viewMode) {
            if(this.props.bill?.id) this.props.getSchldPmts(this.props.bill?.id);
        }

        if (this.props.scheduledPayments != prevProps.scheduledPayments) {
            this.setState({ scheduledPayments: this.props.scheduledPayments });
        }

        if (this.props.bill !== prevProps.bill) {
            this.setState({ bill: this.props.bill });
        }

    }

    cancelBillPayment = (billId, paymentId) => {
        apiPOSTReq(`${environment.payBaseUrl}/payables/cancelBillSchedule`, { "BankProvider": environment.bankProvider.crb }, { billId: billId, objectId: paymentId }, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    this.props.getBill(billId, (bill) => {
                        this.props.updateBillVendor({ bill });
                        this.getSchldPmts(bill.id);
                    });
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                }
            } catch (error) {
                console.log("ERRR /payables/bills/delete", error, err, resp);
                ErrorAlert({ description: error.message });
            }
        })
    }

    render() {
        const { isExpanded, scheduledPayments, bill } = this.state;
        const { title, showDivider, theme } = this.props;
        var { amount, payments } = bill;

        var scheduledAmt = 0;
        scheduledPayments.forEach(pmnt => {
            scheduledAmt += parseFloat(pmnt.amount)
        });

        payments = payments || [];
        var paymentsTotal = 0;
        var paidpayments = payments.filter(pmt => ["Initiated", "Pending", "Processing", "Paid", "On Hold", "Compliance Alert", "Completed"].includes(pmt.paymentStatus));
        paidpayments.forEach(pmnt => { paymentsTotal += parseFloat(pmnt.amount) });

        return (
            (paymentsTotal + scheduledAmt) > 0 ?
            <>
                {showDivider && <Divider margin='4px 0px' />}   
                <FlexColumn gap='4px'>
                    <Flex centerH between gap='24px'>
                        <Text size='16px' weight={600}>{title || 'Payments'}</Text>
                        {/* <LucideIcon size='20px' icon={!isExpanded ? ChevronDown : ChevronUp} onClick={() => this.setState({ isExpanded: !isExpanded })} /> */}
                        <a style={{ textDecoration: "underline", color: hexToRgba(theme.colors.primary2, 0.6), fontSize: '14px' }} onClick={() => this.setState({ isExpanded: !isExpanded })}>
                            {!isExpanded ? 'View payments' : 'Hide payments'}
                        </a>
                    </Flex>
                    
                    <PaymentProgressChart
                        totalAmount={amount}
                        paidAmount={paymentsTotal}
                        scheduledAmount={scheduledAmt}
                    />

                    {
                        isExpanded &&
                        <FlexColumn gap='30px' style={{ background: hexToRgba(theme.colors.primary2, 0.05), padding: "30px 20px", borderRadius: '15px', marginTop: '15px' }}>  
                            {
                                (payments || []).length > 0 &&
                                <BillPaymentTable
                                    payments={payments}
                                    borderView
                                    descText={`A total of $${toAbsCurrency(paymentsTotal, 2)} has been paid towards this bill`}
                                />
                            }
                            {(scheduledPayments || []).length > 0 && (payments || []).length > 0 && <Divider margin='0px 0px' style={{ padding: "0 25px" }} color={hexToRgba(theme.colors.primary2, 0.1)} />}
                            {
                                (scheduledPayments || []).length > 0 &&
                                <BillPaymentScheduledTable
                                    payments={scheduledPayments.map(pmnt => {
                                        var status = pmnt.status
                                        if (status == "Scheduled" && pmnt.scheduledDate) {
                                            status = `Scheduled for ${moment(pmnt.scheduledDate).format(environment.defaultDateFormat)}`
                                        }
                                        return {
                                            paymentId: pmnt.objectId || pmnt.id,
                                            date: getDateInLocalTZ(pmnt.createdAt),
                                            amount: pmnt.amount,
                                            status: status
                                        }
                                    })}
                                    cancelBillPayment={(paymentId) => this.cancelBillPayment(bill.id, paymentId)}
                                    descText={`Payments totaling $${toAbsCurrency(scheduledAmt, 2)} are scheduled or pending approval`}
                                    borderView
                                />
                            }
                        </FlexColumn>
                    }
                </FlexColumn>         
            </>
            :
                null
        );
    }
}

// Default props
PaymentHistory.defaultProps = {
    bill: {},
    title: 'Payments',
    scheduledPayments: [],
    showDivider: true
};

export default withTheme(PaymentHistory);